export default {
  default: ({ bs }) => {
    const { height } = bs

    if (height <= 24 || height === 'smal') {
      return {
        fontSize: 'caption',
        fontWeight: 'regular',
        lineHeight: 'caption',
      }
    }
    if (height <= 32 || height === 'medium') {
      return {
        fontSize: 'body',
        fontWeight: 'regular',
        lineHeight: 'body',
      }
    }
    if (height <= 40 || height === 'large') {
      return {
        fontSize: 'f4',
        fontWeight: 'regular',
        lineHeight: 'f4',
      }
    }
    if (height > 40 || height === 'jumbo') {
      return {
        fontSize: 'f3',
        fontWeight: 'regular',
        lineHeight: 'f3',
      }
    }
    return {
      fontSize: 'body',
      fontWeight: 'regular',
      lineHeight: 'body',
    }
  },
}
